export enum FilterTypes {
  folder = 'folder',
  closed = 'closed',
  finished = 'finished',
  inProgress = 'in_progress',
  pending = 'pending',
  premieres = 'premieres',
  ranking_by_tags = 'ranking_by_tags',
  upcoming = 'upcoming',
  popular = 'popular',
}
